import { render, staticRenderFns } from "./CameraTestProxy.vue?vue&type=template&id=231fe0ec&"
import script from "./CameraTestProxy.vue?vue&type=script&lang=js&"
export * from "./CameraTestProxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('231fe0ec')) {
      api.createRecord('231fe0ec', component.options)
    } else {
      api.reload('231fe0ec', component.options)
    }
    module.hot.accept("./CameraTestProxy.vue?vue&type=template&id=231fe0ec&", function () {
      api.rerender('231fe0ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/test/camera/CameraTestProxy.vue"
export default component.exports